<mat-dialog-content style="padding: 24px !important;" class="relative p-6 w-[335px] h-[428px] lg:w-[508px] lg:h-[516px] bg-white rounded-lg">
    <!-- Header -->
    <header class="flex w-full h-[88px] items-center justify-center bg-[#F2F4F7] relative">
      <h2 class="text-lg font-bold text-center">Select BNPL method</h2>
      <!-- Close Button (X) -->
      <button mat-icon-button (click)="closeDialog()" class="absolute top-[30px] right-[35px] w-[15px] h-[15px]">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <!-- BNPL Options -->
    <div class="mt-4 flex flex-col gap-4">
      <!-- <label class="flex items-center gap-4 p-4 border rounded-lg cursor-pointer" (click)="selectedBNPL = 'Palmcredit'">
        <img src="assets/palmcredit-logo.png" alt="Palmcredit" class="w-8 h-8" />
        <div class="flex flex-col">
          <span class="font-medium">Palmcredit</span>
          <span class="text-sm text-gray-500">Pay with palmcredit</span>
        </div>
        <mat-radio-button class="ml-auto" [checked]="selectedBNPL === 'Palmcredit'"></mat-radio-button>
      </label> -->

      <label class="flex items-center gap-4 p-4 border rounded-lg cursor-pointer" (click)="selectedBNPL = 'Klump'">
        <img src="../../../assets/icons/Klump-logo.svg" class="w-[3.25rem] h-[3.25rem]" />
        <div class="flex flex-col">
          <span class="font-medium">Klump</span>
          <span class="text-sm text-gray-500">Pay with Klump</span>
        </div>
        <mat-radio-button class="ml-auto" color="accent" [checked]="selectedBNPL === 'Klump'"></mat-radio-button>
      </label>

      <label class="flex items-center gap-4 p-4 border rounded-lg cursor-pointer" (click)="selectedBNPL = 'Stanbic_BNPL'">
        <img src="../../../assets/icons/stanbic-logo.svg" alt="Stanbic IBTC" class="w-[3.25rem] h-[3.25rem]" />
        <div class="flex flex-col">
          <span class="font-medium">Stanbic IBTC</span>
          <span class="text-sm text-gray-500">Pay with &#64;ease and bank account</span>
        </div>
        <mat-radio-button class="ml-auto" color="accent" [checked]="selectedBNPL === 'Stanbic_BNPL'"></mat-radio-button>
      </label>
    </div>

    <div class="flex gap-[14px] mt-6">
      <img src="../../../assets/icons/Info-icon.svg" alt="info" class="w-4 h-4">
      <p class="text-sm font-medium text-[#667085]">Amount cannot be less than &#8358;50,000</p>
    </div>
    <!-- Proceed Button -->
    <div class="mt-6 flex justify-center">
      <button (click)="proceed()" [disabled]="!selectedBNPL"
        class="w-full py-3 bg-black text-white rounded-lg font-medium disabled:opacity-50">
        Proceed
      </button>
    </div>
  </mat-dialog-content>
